/**
 * @param preferenceCenter {HTMLElement}
 * @return {void}
 */
module.exports = function uncheckAllPreferenceCenterOptions(preferenceCenter) {
    document.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
        if (checkbox instanceof HTMLInputElement) {
            checkbox.checked = false;
        }
    });

    preferenceCenter.querySelectorAll('[name="unsubscribeAll"]').forEach(unsubscribeAllCheckbox => {
        unsubscribeAllCheckbox.checked = true;
    });
}
